









import { Component, Vue } from "vue-property-decorator";

/**
 * A vue-router navigation element in Rhenus corporate design
 *
 * Use it just like `<router-link>`.
 **/
@Component
export default class DiamondButton extends Vue {}
